import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter,
  AfterContentChecked
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
import { AuthorizeService } from 'app/service/authorize.service'
import { isAbsolute } from 'path'
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-contact-table',
  templateUrl: './contact-table.component.html',
  styleUrls: ['./contact-table.component.scss']
})
export class ContactTableComponent implements OnInit, OnDestroy, AfterContentChecked {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  @Input() companyProfile: any
  @Input() printPage
  @Input() exportFunctions: Map<String, Function>
  @Output() emitEditCase: EventEmitter<any> = new EventEmitter()

  dtTrigger: Subject<any> = new Subject()
  subscription: Subscription
  subscriptionSearch: Subscription
  form: FormGroup
  contactDataTableOptions: DataTables.Settings = {}
  contactDataTableOptionsConfig: DataTables.Settings = {}
  type
  print = false
  pdf = false
  displayHeader = true
  initTableFirstTime = false
  listedContactHeader
  mockupData = []
  listTable = []
  listHeader
  hiddenBtn = true
  symbolValue
  asc = 1
  desc = -1
  isAE
  dataExcelContact = []
  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params


    if (symbol !== undefined) {
      this.symbolValue = symbol
      this.cpmService.getIsAE(this.symbolValue).then(ae => {
        this.isAE = ae
      })
      this.getInformation(this.symbolValue)
    } else {
      this.subscription = this.store.getSecurityProfileNewResultObservable().subscribe(response => {
        if (!response) {
          return
        }
        this.isAE = response['ae']
        this.getInformation(response['securitySymbol'])
      })
    }

    this.listTable = []

    this.listedContactHeader = [
      // 'No.',
      'Name',
      'Surname',
      'Position',
      'Department',
      'Roles & Responsibilities',
      'Office number',
      'Mobile number',
      'Email',
      'Status',
      'Priority',
      'Note',
      'Record date',
      'Source'
    ]

    this.contactDataTableOptions = {
      autoWidth: false,
      paging: false,
      searching: true,
      info: false,
      scrollX: true,
      scrollCollapse: true,
      ordering: true,
      destroy: true,
      scrollY: '320px',
      language: {
        emptyTable: 'No information found'
      },
      // order: [[1, 'asc']],
      order: []
    }

    this.contactDataTableOptionsConfig = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      // scrollX: true,
      ordering: false,
      destroy: true,
      language: {
        emptyTable: 'No information found'
      }
    }
  }

  getDataTableConfig() {
    if (!this.printPage) {
      return this.contactDataTableOptions
    } else {
      return this.contactDataTableOptionsConfig
    }
  }

  getInformation(symbol) {

    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }
    this.listTable = []

    this.cpmService.getCompanyContactList(symbol).then(
      success => {
        this.listTable = success
        this.excelContact()
        if (!this.initTableFirstTime) {
          this.dtTrigger.next()
          this.initTableFirstTime = true
        } else {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.dtTrigger.next()
          })
        }
        
      },
      err => { }
    )
  }

  ngAfterContentChecked() {
    let x = document.getElementsByClassName('dataTables_scrollBody');
    if (x[0]) {
      if (x[0].scrollHeight > x[0].clientHeight) document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("scrollHeadInner");
      else document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("noScrollHeadInner");
    }
  }

  sortList(list, key, sort) {
    list.sort((obj1, obj2) => {
      if (obj1[key] > obj2[key]) {
        return 1 * sort
      }
      if (obj1[key] < obj2[key]) {
        return -1 * sort
      }
      return 0
    })

    return list
  }

  moreThan10Char(word) {
    if (word.length <= 20) {
      return word
    } else if (word.length > 20) {
      return word.toStringLocal() + '...'
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  editCase(data) {
    this.emitEditCase.emit({
      id: data.id,
      symbol: this.symbolValue,
      createBy: data.createBy
    })
  }

  createClick() {
    this.emitEditCase.emit({
      id: '',
      symbol: this.symbolValue,
      createBy: null
    })
  }

  addData(data) {
    this.mockupData.push(data)
  }

  get isUserHasEditPermission() {
    return (
      this.authorization.hasRole('CRM_CONTACT_EDIT')
    )
  }
  excelContact() {
    this.dataExcelContact = []
    this.dataExcelContact.push(this.listedContactHeader)
    this.listTable.map(data => {
      const date = this.datePipe.transform(data.recordDate, 'd MMM yyyy')
      const status = data.status === 'InActive' ? 'Inactive' : data.status
      const priority = data.priority === 'N' ? null : data.priority
      this.dataExcelContact.push([data.firstName, data.lastName,
      data.position, data.department, data.role, data.telOffice, data.telMobile, data.email,
      status, priority, data.note, date, data.source])
    })
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/contact-table/contact-table.component.ts